module.exports = __webpack_public_path__ + "static/media/synthwavejitter.1f410a8f.mp4";